//@ts-nocheck
import React, { useEffect, useState } from 'react'
import {
  Box,
  Chip,
  Grid,
  Typography,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import CloseIcon from '@mui/icons-material/Close'
import QualificationsApp from '../QualificationsApp'
import { useTranslation } from 'react-i18next'
import { useGlobalStateContext } from '../../context/globalState'
import { CONSTANTS } from '../../CONSTANTS'

interface TrainingListProps {
  handleTrainingData: (
    trainings: {
      title: string
      expirationDate: string
      completionDate: string
      type: string
    }[],
  ) => void
  training?: []
  passportLevel?:number ,
  qualificationType?:string
  profileFormData?: any
  qualifiedToWorkCountry?: any
  onEditClick?: () => boolean
  selectedCountryId?: any
  countryList?: any[]
}

const TrainingList: React.FC<TrainingListProps> = ({ handleTrainingData, profileFormData, qualifiedToWorkCountry, onEditClick, selectedCountryId, countryList}) => {

  const {
    qualificationsList,
    setQualificationsList,
    trainingTypes
  } = useGlobalStateContext()

  const [showForm, setShowForm] = useState(false)
  const { t } = useTranslation()
  const [globalSafety, setGlobalSafety] = useState<any[]>([])
  const [localSafety, setLocalSafety] = useState<any[]>([])
  const [method, setMethod] = useState<any[]>([])
  const [selectedTrainings, setSelectedTrainings] = useState<any[]>([]);
  const [previousQualifications, setPreviousQualifications] = useState<{
    [key: string]: {
      completionDate: string | null
      expirationDate: string | null
      type: string
    }
  }>([])

  useEffect(() => {
    if (qualificationsList) {
      // Now update the states for different categories (GlobalSafety, LocalSafety, Method)
    const globalSafetyTrainings = qualificationsList.filter(
      (training) => training.type === trainingTypes.GLOBAL_SAFETY,
    )
    const localSafetyTrainings = qualificationsList.filter(
      (training) => training.type === trainingTypes.LOCAL_SAFETY,
    )
    const methodTrainings = qualificationsList.filter(
      (training) => training.type === trainingTypes.METHOD,
    )

    setGlobalSafety(globalSafetyTrainings)
    setLocalSafety(localSafetyTrainings)
    setMethod(methodTrainings)
    }
  }, [qualificationsList])


  const handleDelete = (type: string, trainingId: number) => {
    if (type === 'globalSafety') {
      setGlobalSafety(globalSafety.filter((qual) => qual.trainingId !== trainingId))
    } else if (type === 'localSafety') {
      setLocalSafety(localSafety.filter((qual) => qual.trainingId !== trainingId))
    } else if (type === 'method') {
      setMethod(method.filter((qual) => qual.trainingId !== trainingId))
    }
    setQualificationsList(qualificationsList.filter((qual) => qual.trainingId !== trainingId))
  }

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, training: any) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      // Add to selected trainings if checked
      setSelectedTrainings((prevSelected) => [...prevSelected, training]);
    } else {
      // Remove from selected trainings if unchecked
      setSelectedTrainings((prevSelected) =>
        prevSelected.filter((t) => t.title !== training.title)
      );
    }
  };

  const toggleForm = () => {
    // Call parent's validation function
    if (onEditClick && !onEditClick()) {
      return
    }
    setShowForm((prev) => !prev)
  }


  const renderQualificationSection = (type: string, data: any[]) => {
    return (
      <>
        {data.length > 0 && (
          <Grid container spacing={2} alignItems="left" sx={{ mb: 2 }}>
            <Grid item xs={3}>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {type === 'globalSafety' && t('adminDashboard.form.updateInstaller.labels.qualifications.globalSafety')}
                {type === 'localSafety' && t('adminDashboard.form.updateInstaller.labels.qualifications.localSafety')}
                {type === 'method' && t('adminDashboard.form.updateInstaller.labels.qualifications.method')}
              </Typography>
            </Grid>
            <Grid item xs={9}>
              {data.map((item, index) => {
                const palette =
                  type === 'globalSafety'
                    ? { bg: '#F6F8FF', border: '#B8B6E0' }
                    : type === 'localSafety'
                      ? { bg: '#FEF8E7', border: '#D6A533' }
                      : { bg: '#DFDEFD', border: '#918DF6' }
                return (
                  <Chip
                    key={index}
                    label={`${item.title} ${item.expirationDate ? ` - Exp: ${item.expirationDate}` : ''}`}
                    onDelete={() => handleDelete(type, item.trainingId)}
                    deleteIcon={<CloseIcon />}
                    sx={{
                      m: 0.5,
                      backgroundColor: palette.bg,
                      border: `1px solid ${palette.border}`,
                    }}
                  />
                )
              })}
            </Grid>
          </Grid>
        )}
      </>
    )
  }


  return (
    <Grid container sx={{ justifyContent: 'flex-start', width: '100%' }}>
      <Box
        sx={{
          width: '100%',
          maxWidth: '900px',
          mx: 'auto',
          p: 2,
          backgroundColor: '#e7eaf6', borderRadius: 2
        }}
      >
        {renderQualificationSection('globalSafety', globalSafety)}
        {renderQualificationSection('localSafety', localSafety)}
        {renderQualificationSection('method', method)}

        {globalSafety.length === 0 && localSafety.length === 0 && method.length === 0 && (
          <Box sx={{ display: 'flex', justifyContent: 'left' }}>
            <Typography variant="h6" sx={{ color: CONSTANTS.COLORS.TEXT_GRAY, fontSize: '16px' }}>
              {t('adminDashboard.form.addInstaller.labels.qualification')}
            </Typography>
          </Box>
        )}
        <Box sx={{ textAlign: 'right', mt: 2 }}>
          <IconButton size="large" onClick={toggleForm}>
            <EditIcon fontSize="inherit" />
          </IconButton>
        </Box>

        {/* QualificationsApp dialog */}
        <Dialog open={showForm} onClose={toggleForm} maxWidth="lg" fullWidth>
          <DialogContent>
            <QualificationsApp
              onClose={toggleForm}
              previousQualifications={previousQualifications}
              selectedTrainings={selectedTrainings} // Pass selected trainings
              onCheckboxChange={handleCheckboxChange} // Handle checkbox changes
              profileFormData={{...profileFormData, country: selectedCountryId}}
              countryList={countryList}
            />
          </DialogContent>
        </Dialog>
      </Box>
    </Grid>
  )
}

export default TrainingList
